import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'retailPrice'
})
export class RetailPricePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const RETAIL_PRICING = 1,
          DISCOUNT_PRICING = 2,
          BOGO_PRICING = 3,
          FREE_GUEST_PRICING = 4,
          DROPIN_PRICING = 5;
    switch (value.pricing_type_id) {
      case RETAIL_PRICING:
        return this.isFreeDropIn(value) ? this.maybeFree(value.retail_value) : '';
      case DISCOUNT_PRICING:
        if (this.getRetailCost(value) === this.getDiscountCost(value)) {
          return '';
        } else if (this.getRetailCost(value) > this.getDiscountCost(value))  {
          return this.getCurrency(this.getRetailCost(value), 0, false);
        }
        break;
      case FREE_GUEST_PRICING:
      case DROPIN_PRICING:
            return '';
    }
  }

  maybeFree(price) {
    return (price === 0) ? 'Free/By Donation' : this.getCurrency(price, 0, false);
  }

  getCurrency(val, digits, forceZero) {
    const PREFIX  = '$',
    POSTFIX = ' CAD',
    FREE    = 'FREE';
    const num = Number(val),
        fixed = digits ? digits : 2;
    if (val) {
        return PREFIX + num.toFixed(fixed) + POSTFIX;
    } else {
      return forceZero ? PREFIX + Number(0).toFixed(fixed) + POSTFIX : FREE;
    }
  }

  isFreeDropIn(promo) {
    return promo.free_drop_in === 1;
  }

  getRetailCost(promo) {
    return promo.retail_value;
  }

  getDiscountCost(promo) {
    return promo.total_amount;
  }
}
